import { getRootEntity } from 'client/reducers/pageReducer'
import { useManagement, usePage } from 'client/store'
import managementSelectors from 'client/store/management/managementSelectors'
import { BaseEntityBodyInterface } from 'common/types/entities/EntityInterface'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { CheckboxControl } from 'src/editor/shared/settings/checkbox-control'
import { Tooltip } from 'src/shared/components/tooltip'
import { useUpdateProp } from '../../hooks/useUpdateProps'

export const Affiliate = <T extends BaseEntityBodyInterface>() => {
  const { t } = useTranslation()
  const entity = usePage(getRootEntity) as T
  const isUserFreemium = useManagement(managementSelectors.isUserFreemium)
  const updateProp = useUpdateProp<T>(entity)

  const toggleAffiliateBadge = (checked: boolean) => {
    if (isUserFreemium) {
      return
    }
    updateProp('isAffiliateBadgeVisible')(checked)
  }

  return (
    <>
      <GroupTitle>entity_settings.body.affiliate.title</GroupTitle>
      <div className="mb-5 flex items-center">
        <CheckboxControl
          update={toggleAffiliateBadge}
          label="entity_settings.body.affiliate.badge.label"
          tooltipText="entity_settings.body.affiliate.badge.description"
          value={isUserFreemium || entity?.isAffiliateBadgeVisible}
          disabled={isUserFreemium}
        />
        {isUserFreemium && (
          <Tooltip
            message={t(
              'entity_settings.body.affiliate.badge.freemium_help_message',
            )}
          />
        )}
      </div>
    </>
  )
}
